/**
 * Kontakt zum Plattformbetreiber NextCab. Bewusst NICHT aus brandingConfig: Dort steht in
 * den gebrandeten Portalen die Adresse des Mandanten. Was über diesen Kontakt läuft, muss
 * aber bei NextCab landen (Gerätebestellung Taxi Butler, Fachbegriffe für den
 * KI-Telefonisten). Der Wert ist deshalb in jeder Instanz gleich.
 */
export const NEXTCAB_SUPPORT = { email: 'info@nextcab.de', phone: '+49 176 570 15 830' };
